function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { Gallery } from '@shared/components/galleryPage';
import { getFilteredServiceData } from '@shared/actions/thunkActions';
import { createSearchboxInputChangedAction, createUpdateCurrentGalleryViewIsCurated } from '@shared/actions/actions';
import { getEntityRegistrationByView } from '@shared/utils/entityRegistration';
import { getInternetOfThingsLink } from '@shared/utils/filterHelpers';
import { extractCountryCodeFromQueryParam } from '@shared/utils/consultingServicesUtils';
import { Constants } from '@shared/utils/constants';
import { withRouter } from '@shared/routerHistory';
import { connect } from 'react-redux';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
import { isMaccUser } from '@shared/utils/userUtils';
function tryParseInt(val) {
    let parsedVal = parseInt(val, 10);
    if (isNaN(parsedVal)) {
        parsedVal = null;
    }
    return parsedVal;
}
export const mapStateToProps = (state, ownProps)=>{
    var _ownProps_location_query_showPrivateApps, _ownProps_params;
    const { config: { requestFilteredQuery, query: queryProp, featureFlags, locale, isEmbedded, isMobile, isAppSource, embedHost, requestFilteredLoading, currentView, billingCountryCode }, apps, services, cloudsIndustry } = state;
    const pageSize = tryParseInt(ownProps.location.query.pageSize);
    const galleryPage = tryParseInt(ownProps.location.query.page);
    const showPrivateApps = ((_ownProps_location_query_showPrivateApps = ownProps.location.query.showPrivateApps) === null || _ownProps_location_query_showPrivateApps === void 0 ? void 0 : _ownProps_location_query_showPrivateApps.toLowerCase()) === 'true';
    const linksList = getInternetOfThingsLink((_ownProps_params = ownProps.params) === null || _ownProps_params === void 0 ? void 0 : _ownProps_params.category);
    const query = _object_spread({}, requestFilteredQuery, ownProps.location.query);
    const subsetSearchQuery = requestFilteredQuery[Constants.TileDataFilteredQueryParams.search];
    const countryCode = extractCountryCodeFromQueryParam(queryProp) || billingCountryCode || state.services.selectedCountry;
    var _query_region;
    const regionCode = (_query_region = query === null || query === void 0 ? void 0 : query.region) !== null && _query_region !== void 0 ? _query_region : state.services.selectedRegion;
    const dataList = state.apps.dataList.filter(({ entityId })=>!isOneTimePaymentOffer(entityId));
    const entityType = getEntityRegistrationByView(currentView);
    const showRecommendations = state.config.featureFlags.recommendations;
    const { whatsNewApps, trendingApps } = state.apps.recommendedApps;
    const { whatsNewService, trendingService } = state.services.recommendedServices;
    return {
        galleryPage,
        pageSize,
        requestFilteredLoading,
        entityData: {
            [Constants.EntityType.App]: {
                allData: dataList,
                subsetData: state.apps.subsetData,
                dataMap: state.apps.dataMap,
                idMap: state.apps.idMap,
                subsetSearchQuery,
                curatedData: state.apps.curatedData,
                activeFilters: state.apps.activeFilters,
                count: state.apps.count,
                countriesList: {}
            },
            [Constants.EntityType.Service]: {
                allData: state.services.dataList,
                subsetData: state.services.subsetData,
                dataMap: state.services.dataMap,
                idMap: state.services.idMap,
                subsetSearchQuery,
                curatedData: state.services.curatedData,
                activeFilters: state.services.activeFilters,
                count: state.services.count,
                countriesList: state.services.countriesList
            },
            [Constants.EntityType.CloudsIndustry]: {
                allData: state.cloudsIndustry.dataList,
                subsetData: state.cloudsIndustry.subsetData,
                dataMap: state.cloudsIndustry.dataMap,
                idMap: state.cloudsIndustry.idMap,
                subsetSearchQuery,
                curatedData: state.cloudsIndustry.curatedData,
                activeFilters: state.cloudsIndustry.activeFilters,
                count: state.cloudsIndustry.count,
                countriesList: state.services.countriesList
            }
        },
        showPrivateApps,
        isEmbedded,
        partnerAppDataLoaded: apps.partnerAppDataLoaded,
        partnerAppDataLoadedError: apps.partnerAppDataLoadedError,
        embedHost,
        entityType,
        query,
        params: ownProps.params,
        countryCode,
        regionCode,
        isAppSource,
        isMobile,
        currentView,
        selectedLocale: locale,
        linksList,
        appsActiveFilters: apps.activeFilters,
        servicesActiveFilters: services.activeFilters,
        cloudsIndustryActiveFilters: cloudsIndustry.activeFilters,
        featureFlags,
        selectedCountry: state.services ? state.services.selectedCountry : null,
        recoMicrosoft365WhatsNewItems: showRecommendations ? apps.recommendedApps.microsoft365WhatsNewApps : [],
        recoMicrosoft365TrendingItems: showRecommendations ? apps.recommendedApps.microsoft365TrendingApps : [],
        recoWhatsNewItems: showRecommendations && (entityType === Constants.EntityType.App ? whatsNewApps : entityType === Constants.EntityType.Service ? whatsNewService : []),
        recoTrendingItems: showRecommendations && (entityType === Constants.EntityType.App ? trendingApps : entityType === Constants.EntityType.Service ? trendingService : []),
        isMaccUser: isMaccUser(state.users)
    };
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        stateCountryFilterHandler: ()=>{
            dispatch(getFilteredServiceData());
        },
        updateCurrentGalleryViewIsCurated: (isCuratedGalleryView)=>{
            dispatch(createUpdateCurrentGalleryViewIsCurated({
                isCuratedGalleryView: isCuratedGalleryView
            }));
        },
        changeSearchText: (searchvalue)=>dispatch(createSearchboxInputChangedAction({
                searchString: searchvalue
            }))
    };
};
const GalleryPageContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Gallery));
export default GalleryPageContainer;
